<template>
  <div class="encounter-box">
    <div class="encounter-home-header">
      <div class="header-row">
        <button class="back-home-btn" @click="$router.push({ path: '/' })">
          <van-icon name="arrow-left" />
        </button>
        <div class="header-main">
          <div class="home-title">
            <img class="home-title-logo" src="../assets/LOGO.jpg" alt="logo">
            <span>鹊桥会</span>
          </div>
          <div class="home-subtitle">{{ headerSummary }}</div>
        </div>
        <button class="header-action" @click="handleHeaderAction">
          <van-icon :name="activeTab === 'more' ? 'cross' : 'filter-o'" />
        </button>
      </div>

      <div class="encounter-tabs">
        <div class="tab-item" :class="{ active: activeTab === 'recommend' }" @click="switchTab('recommend')"
          v-if="isMember">
          AI推荐
        </div>
        <!-- <div class="tab-item" :class="{ active: activeTab === 'aimatch' }" @click="switchTab('aimatch')">
          AI匹配
        </div> -->
        <div class="tab-item" :class="{ active: activeTab === 'latest' }" @click="switchTab('latest')">
          最新
        </div>
        <div class="tab-item" :class="{ active: activeTab === 'more' }" @click="switchTab('more')">
          更多
        </div>
      </div>
    </div>

    <div class="encounter-filter-panel" v-if="activeTab === 'more'">
        <MoreFilter ref="moreFilter" :initial-state="moreFilterInitialState" />
    </div>

    <div class="encounter-main" :class="{ 'has-floating-cta': role === 'GeneralUser' && activeTab !== 'more' }" v-else>
      <div class="section-head">
        <div class="section-head-copy">
          <div class="title-text">{{ sectionTitle }}</div>
          <div class="title-desc">{{ sectionDesc }}</div>
        </div>
      </div>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="member-list recommend-list">
            <div v-for="item in memberList" :key="item.id" class="member-card recommend-card"
              @click="handleMemberClick(item)">
              <div class="member-cover">
                <img :src="getMemberAvatar(item)" alt="" />
                <MatchRateBadge
                  v-if="(activeTab === 'recommend' && item.matchRate !== undefined) || (activeTab === 'aimatch' && item.matchScore !== undefined)"
                  :matchRate="activeTab === 'aimatch' ? item.matchScore : item.matchRate" class="cover-match-badge" />
                <span class="cover-badge" v-else-if="activeTab === 'latest'">最新加入</span>
                <span class="cover-badge" v-else-if="activeTab === 'recommend'">精选推荐</span>
              </div>
              <div class="member-body">
                <div class="member-title-row">
                  <div class="member-title-main">
                    <span class="name">{{ item.nickName || formatSerial(item.serialNumber) }}</span>
                    <span class="serial">ID:{{ formatSerial(item.serialNumber) }}</span>
                    <!-- <span class="age age-inline">{{ calculateAge(item.birthday) }}岁</span> -->
                  </div>
                </div>

                <div class="member-grid">
                  <div class="grid-item">
                    <span class="label">年龄</span>
                    <span>{{ calculateAge(item.birthday) }}岁</span>
                  </div>
                  <div class="grid-item">
                    <span class="label">学历</span>
                    <span>{{ getEducationText(item.education) }}</span>
                  </div>
                  <div class="grid-item">
                    <span class="label">身高</span>
                    <span>{{ item.height }}cm</span>
                  </div>
                </div>

                <div class="member-info-tag member-match-reason"
                  v-if="(activeTab === 'aimatch' || activeTab === 'recommend') && item.matchReason">
                  <span class="member-info-tag__badge">AI</span>
                  <span class="member-info-tag__label">推荐理由</span>
                  <span class="member-info-tag__text">{{ item.matchReason }}</span>
                </div>

                <!-- <div class="member-birthday">
                  出生日期 · {{ formatBirthday(item.birthday) || "未填写" }}
                </div> -->

                <!-- <div class="member-declaration" v-if="item.datingDeclaration">
                  交友宣言 · {{ formatDeclaration(item.datingDeclaration) }}
                </div> -->

                <div class="member-info-tag member-declaration" v-if="item.datingDeclaration">
                  <span class="member-info-tag__icon">💗</span>
                  <span class="member-info-tag__label">交友宣言</span>
                  <span class="member-info-tag__text">{{ formatDeclaration(item.datingDeclaration) }}</span>
                </div>

                <div class="basic-footer" v-if="activeTab === 'more'">
                  <div class="footer-tip">{{ isMember ? '查看详细资料' : '非会员不可查看会员详情' }}</div>
                  <div class="footer-actions">
                    <button v-if="isMember" class="favorite-btn"
                      :class="{ 'favorite-btn--active': favoriteMap[item.id] }" @click.stop="toggleFavorite(item)">
                      <van-icon :name="favoriteMap[item.id] ? 'like' : 'like-o'" size="0.8rem" />
                      <span>{{ favoriteMap[item.id] ? '已收藏' : '收藏' }}</span>
                    </button>
                    <button class="detail-btn" @click.stop="handleMemberClick(item)">
                      {{ isMember ? '查看详情' : '仅会员可见' }}
                    </button>
                  </div>
                </div>
                <div class="basic-footer basic-footer--simple" v-else>
                  <div class="footer-actions">
                    <button v-if="isMember" class="favorite-btn"
                      :class="{ 'favorite-btn--active': favoriteMap[item.id] }" @click.stop="toggleFavorite(item)">
                      <van-icon :name="favoriteMap[item.id] ? 'like' : 'like-o'" size="0.8rem" />
                      <span>{{ favoriteMap[item.id] ? '已收藏' : '收藏' }}</span>
                    </button>
                  <button class="detail-btn" @click.stop="handleMemberClick(item)">
                {{ isMember ? '查看详情' : '仅会员可见' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="empty-state" v-if="memberList.length === 0 && !loading">
              <div class="empty-icon">🌸</div>
              <p class="empty-text">{{ activeTab === 'latest' ? '暂无最新成员' : (activeTab === 'aimatch' ? '暂无AI匹配结果' :
                '暂无推荐成员') }}</p>
              <p class="empty-hint">{{ activeTab === 'latest' ? '稍后再来看看新加入的会员吧' : (activeTab === 'aimatch' ?
                '完善个人资料和标签后再来试试' : '稍后再来看看吧') }}</p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <button v-if="role === 'GeneralUser' && activeTab !== 'more'" class="join-member-float" @click="handleJoinMember">
      我要做会员
    </button>

    <TabBar active-key="encounter" v-if="role === 'Member' || role === 'Matchmaker'" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import { mapGetters } from "vuex";
import { getEncounterMemberList, getSmartRecommendMembers, getAiMatchMembers } from "@/api/user";
import { addFavorite, removeFavorite, checkFavorites } from "@/api/memberFavorite";
import { navigateToJoinMember } from "@/utils/memberEntry";
import defaultAvatar from "../assets/defaultPhoto.png";
import MoreFilter from "@/components/encounter/MoreFilter.vue";
import MatchRateBadge from "@/components/encounter/MatchRateBadge.vue";

export default {
  components: { MoreFilter, TabBar, MatchRateBadge },
  data() {
    return {
      memberList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      defaultAvatar: defaultAvatar,
      activeTab: "recommend",
      favoriteMap: {},
      favoriteLoading: false,
      aiMatchLoading: false,
      tabCache: {},
      moreFilterInitialState: null
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "role"]),
    isMember() {
      return this.role === "Member";
    },
    targetSex() {
      const currentSex = this.baseInfo.sex;
      return this.baseInfo.spouseSex ? Number(this.baseInfo.spouseSex) : (currentSex === 1 ? 2 : 1);
    },
    sectionTitle() {
      const map = {
        recommend: "推荐会员",
        aimatch: "AI智能匹配",
        latest: "最新加入"
      };
      return map[this.activeTab] || "推荐会员";
    },
    sectionDesc() {
      const map = {
        recommend: "鹊桥会AI 为你精挑细选，每一次划动都离缘分更近一步",
        latest: "最近加入平台的会员都在这里",
        aimatch: "AI根据你的信息智能匹配，找到最合适的人"
      };
      return map[this.activeTab] || "鹊桥会AI 为你精挑细选，每一次划动都离缘分更近一步";
    },
    headerSummary() {
      if (this.activeTab === "latest") {
        return "最新加入 · 浏览近期新成员";
      }
      if (this.activeTab === "more") {
        return "更多筛选 · 精准查找心动对象";
      }
      if (this.activeTab === "aimatch") {
        return "AI智能匹配 · 大模型为你推荐";
      }
      return "推荐会员 · 浏览平台精选资料";
    }
  },
  created() {
    if (this.role != "Member") {
      this.activeTab = "latest";
    }
    this.restoreScrollState();
  },
  activated() {
    this.restoreScrollState();
  },
  beforeRouteLeave(to, from, next) {
    this.saveScrollState();
    next();
  },
  methods: {
    getMemberAvatar(item) {
      if (item.personalPhotos && item.personalPhotos.length > 0) {
        const photo = item.personalPhotos[0];
        const url = typeof photo === 'string' ? photo : (photo.url || photo);
        if (url) return url;
      }
      if (item.avatarLink) return item.avatarLink;
      return defaultAvatar;
    },
    handleHeaderAction() {
      if (this.activeTab === "more") {
        this.switchTab("recommend");
        return;
      }
      this.activeTab = "more";
      this.finished = true;
      this.loading = false;
      this.$nextTick(() => {
        if (this.$refs.moreFilter && typeof this.$refs.moreFilter.openSearchPopup === "function") {
          this.$refs.moreFilter.openSearchPopup();
        }
      });
    },
    switchTab(tab) {
      if (this.activeTab === tab) return;
      this.saveTabCache(this.activeTab);
      this.activeTab = tab;
      const cached = this.tabCache[tab];
      if (cached) {
        this.memberList = cached.memberList || [];
        this.page = cached.page || 1;
        this.finished = cached.finished || false;
        this.loading = false;
        this.refreshing = false;
        if (tab === "more" && cached.moreFilterState) {
          this.moreFilterInitialState = cached.moreFilterState;
        } else {
          this.moreFilterInitialState = null;
        }
        this.$nextTick(() => {
          window.scrollTo(0, cached.scrollTop || 0);
        });
      } else if (tab === "more") {
        this.finished = true;
        this.loading = false;
        this.moreFilterInitialState = null;
      } else {
        this.onRefresh();
      }
    },
    async onLoad() {
      await this.loadMemberList();
    },
    async onRefresh() {
      this.page = 1;
      this.memberList = [];
      this.finished = false;
      this.loading = true;
      await this.onLoad();
      this.refreshing = false;
    },
    async loadMemberList() {
      try {
        if (this.activeTab === "recommend") {
          await this.loadSmartRecommendList();
        } else if (this.activeTab === "aimatch") {
          await this.loadAiMatchList();
        } else {
          await this.loadNormalList();
        }
      } catch (error) {
        console.error("加载会员列表失败", error);
        this.loading = false;
        this.finished = true;
      }
    },
    async loadSmartRecommendList() {
      const res = await getSmartRecommendMembers({
        page: this.page,
        pageSize: this.pageSize,
        minMatchRate: 60,
        sex: this.targetSex
      });
      if (res.code === 20000) {
        const data = res.data;
        this.applyPageResults(data.items || []);
      } else {
        this.loading = false;
        this.finished = true;
      }
    },
    async loadAiMatchList() {
      if (this.aiMatchLoading) return;
      this.aiMatchLoading = true;
      try {
        const res = await getAiMatchMembers({
          page: this.page,
          pageSize: this.pageSize,
          sex: this.targetSex
        });
        if (res.code === 20000 && res.data) {
          this.applyPageResults(res.data.items || []);
        } else {
          this.loading = false;
          this.finished = true;
        }
      } catch (error) {
        console.error("AI匹配加载失败", error);
        this.$toast.fail("AI匹配加载失败，请稍后重试");
        this.loading = false;
        this.finished = true;
      } finally {
        this.aiMatchLoading = false;
      }
    },
    async loadNormalList() {
      const currentSex = this.baseInfo.sex;
      // 优先使用择偶要求中选择的性别，没设时才回退到默认（展示异性）
      const targetSex = this.targetSex;
        const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const startDate = new Date(year, month - 1, 1);
      const endDate = new Date(year, month + 1, 0, 23, 59, 59);
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        sex: targetSex
      };
      if (this.activeTab === "latest") {
        params.startTime = this.formatDate(startDate);
        params.endTime = this.formatDate(endDate);
      }
      const res = await getEncounterMemberList(params);
      if (res.code === 20000) {
        this.applyPageResults(res.data.items || []);
      } else {
        this.loading = false;
        this.finished = true;
      }
    },
    applyPageResults(newList) {
      const memberMap = new Map(this.memberList.map(item => [item.id, item]));
      newList.forEach(item => {
        memberMap.set(item.id, item);
      });
      this.memberList = Array.from(memberMap.values());
      this.loading = false;
      if (newList.length < this.pageSize) {
        this.finished = true;
      } else {
        this.page++;
      }
      this.refreshFavoriteStatus();
    },
    async refreshFavoriteStatus() {
      if (!this.isMember || !this.baseInfo || !this.baseInfo.id) return;
      const memberIds = this.memberList.map(item => item.id);
      if (memberIds.length === 0) return;
      try {
        const res = await checkFavorites(this.baseInfo.id, memberIds);
        if (res.code === 20000 && res.data) {
          this.favoriteMap = { ...this.favoriteMap, ...res.data };
        }
      } catch (e) {
        // ignore
      }
    },
    async toggleFavorite(item) {
      if (!this.isMember || !this.baseInfo || !this.baseInfo.id) return;
      if (this.favoriteLoading) return;
      this.favoriteLoading = true;
      const memberId = this.baseInfo.id;
      const favoriteMemberId = item.id;
      const isFav = this.favoriteMap[favoriteMemberId];
      try {
        if (isFav) {
          const res = await removeFavorite(memberId, favoriteMemberId);
          if (res.code === 20000) {
            this.$set(this.favoriteMap, favoriteMemberId, false);
            this.$toast({ message: "已取消收藏", icon: "like-o" });
          } else {
            this.$toast.fail(res.message || "取消收藏失败");
          }
        } else {
          const res = await addFavorite(memberId, favoriteMemberId);
          if (res.code === 20000) {
            if (!res.msg) {
              this.$set(this.favoriteMap, favoriteMemberId, true);
            }
            const toastMsg = res.msg || "已收藏到心仪对象";
            this.$toast({ message: toastMsg, icon: "like" });
          } else {
            this.$toast.fail(res.msg || "收藏失败");
          }
        }
      } catch (e) {
        this.$toast.fail("操作失败");
      } finally {
        this.favoriteLoading = false;
      }
    },
    handleMemberClick(item) {
      if (this.isMember) {
        this.$router.push({ path: `/detailInformation/${item.id}` });
      } else {
        this.$toast("非会员不可查看会员详情");
      }
    },
    handleJoinMember() {
      navigateToJoinMember({
        role: this.role,
        nextRole: this.$store.getters.nextRole,
        router: this.$router,
        toast: message => this.$toast(message)
      });
    },
    getEducationText(education) {
      const educationMap = {
        1: "大专",
        2: "本科",
        3: "硕士",
        4: "博士",
        5: "高中及以下"
      };
      return educationMap[education] || "未知";
    },
    formatBirthday(birthday) {
      if (!birthday) return "";
      const date = new Date(birthday);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    calculateAge(birthday) {
      if (!birthday) return 0;
      const today = new Date();
      const birthDate = new Date(birthday);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    formatSerial(serialNumber) {
      if (!serialNumber) return "0000";
      return String(serialNumber).padStart(4, "0");
    },
    formatDeclaration(text) {
      if (!text) return "";
      return text.length > 30 ? text.slice(0, 30) + "..." : text;
    },
    saveTabCache(tab) {
      if (!tab) return;
      this.$set(this.tabCache, tab, {
        memberList: this.memberList,
        page: this.page,
        finished: this.finished,
        scrollTop: document.documentElement.scrollTop || document.body.scrollTop || 0,
        moreFilterState: this.$refs.moreFilter ? this.$refs.moreFilter.getState() : null
      });
    },
    saveScrollState() {
      try {
        const state = {
          scrollTop: document.documentElement.scrollTop || document.body.scrollTop || 0,
          memberList: this.memberList,
          activeTab: this.activeTab,
          page: this.page,
          finished: this.finished,
          favoriteMap: this.favoriteMap,
          moreFilterState: this.$refs.moreFilter ? this.$refs.moreFilter.getState() : null,
          tabCache: this.tabCache
        };
        sessionStorage.setItem("encounter_scroll_state", JSON.stringify(state));
      } catch (e) {
        // ignore
      }
    },
    restoreScrollState() {
      try {
        const raw = sessionStorage.getItem("encounter_scroll_state");
        if (raw) {
          const state = JSON.parse(raw);
          this.memberList = state.memberList || [];
          this.activeTab = state.activeTab || "recommend";
          this.page = state.page || 1;
          this.finished = state.finished || false;
          this.favoriteMap = state.favoriteMap || {};
          this.tabCache = state.tabCache || {};
          this.loading = false;
          this.refreshing = false;
          if (state.activeTab === "more" && state.moreFilterState) {
            this.moreFilterInitialState = state.moreFilterState;
          } else {
            this.moreFilterInitialState = null;
          }
          this.$nextTick(() => {
            window.scrollTo(0, state.scrollTop || 0);
            this.refreshFavoriteStatus();
          });
          sessionStorage.removeItem("encounter_scroll_state");
        } else {
          this.onRefresh();
        }
      } catch (e) {
        this.onRefresh();
      }
    }
  }
};
</script>
<style lang="less" src="../style/encounter.less" />



// WEBPACK FOOTER //
// src/views/encounter.vue